/* eslint-disable */
import QueryParamsUtil from '../reverb-js-common/query_params_util';

function User() {
  // This may be invoked from the client side, or the server
  // may trigger it as part of a request login validation.
  // See ApplicationController#require_user. When the server
  // triggers the event, there will be no params.
  this.showLightboxFromEvent = function (e, button, formType, _popupSource) {
    const opts = { formType };

    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (button) {
      Object.assign(opts, this.getOptsFromButton(button));
    }

    this.showLightbox(opts);
  };

  this.AUTO_SELECT_TAB = 'ajax_registration_or_login';
  this.LOGIN_TAB = 'ajax_login';
  this.REGISTER_TAB = 'ajax_registration';

  this.showLightbox = function (opts) {
    // Clear the current hash, preventing problems in switching
    // between tabs due to the tab framework thinking we're already
    // engaged on a particular tab.
    window.location.hash = '';

    const formType = opts.formType || this.AUTO_SELECT_TAB;

    const url = this.setupUrlParams(`/${formType}`, opts);

    // @ts-ignore
    Reverb.UI.Ajax.lightbox(url, function bindRegistrationLightbox() {
      const pane = $('.registration .tab-pane.active');

      if (opts.message) {
        $('[data-bind=\'registration-message-content\']').html(opts.message);
        $('[data-bind=\'registration-message\']').show();
      }

      if (opts.contentSelector) {
        const content = $(opts.contentSelector).html();
        $('[data-bind=\'registration-explanation-content\']').html(content);
      }

      if (opts.emailPrefill) {
        pane.find("input[type=email]").val(opts.emailPrefill);
      }

      // focus first input
      pane.find("input[type=text], input[type=email], textarea").
        filter(":visible:enabled:first").
        focus();
    });
  };

  this.getOptsFromButton = function (button) {
    const vals = {};

    vals.popupSource = $(button).data('source');
    vals.message = $(button).data('registration-message');
    vals.contentSelector = $(button).data('registration-explanation-content');
    vals.urlSource = $(button).data('registration-url-source');
    vals.sourceProductUuid = $(button).data('registration-source-product-uuid');

    return vals;
  };

  this.setupUrlParams = function (url, opts) {
    const queryHash = {};
    let queryParams = null;
    let urlWithParams = url;

    if (opts.urlSource) {
      queryHash.source = opts.urlSource;
    }

    if (opts.sourceProductUuid) {
      queryHash.source_product_uuid = opts.sourceProductUuid;
    }

    if (opts.redirectTo) {
      queryHash.redirect_to = opts.redirectTo;
    }

    if (!$.isEmptyObject(queryHash)) {
      queryParams = QueryParamsUtil.queryParamsForUrl(queryHash);
      urlWithParams += queryParams;
    }
    return urlWithParams;
  };

  this.showInlineRegistrationFromServer = function (requestedAction) {
    this.showLightboxFromEvent(null, null, this.AUTO_SELECT_TAB, requestedAction);
  };

  this.showInlineRegistration = function (e, button) {
    this.showLightboxFromEvent(e, button, this.REGISTER_TAB);
  };

  this.showInlineLogin = function (e, button) {
    this.showLightboxFromEvent(e, button, this.LOGIN_TAB);
  };

  this.showInlineRegistrationOrLogin = function (e, button) {
    this.showLightboxFromEvent(e, button, this.AUTO_SELECT_TAB);
  };
};

export default new User();
